import { render, staticRenderFns } from "./StoriesMoreSiblings.vue?vue&type=template&id=147f7396&scoped=true&"
import script from "./StoriesMoreSiblings.vue?vue&type=script&lang=js&"
export * from "./StoriesMoreSiblings.vue?vue&type=script&lang=js&"
import style0 from "./StoriesMoreSiblings.vue?vue&type=style&index=0&id=147f7396&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147f7396",
  null
  
)

export default component.exports